function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import analytics from '../../lib/shared/analytics';
import config from '../../lib/shared/config';
import Log from '../../lib/client/setup/log';
import React from 'react';
import vaultUtil from '../../lib/client/vault-util';
import '../../scss/setup/deploy/_validator.scss';
var _ValidatorController = function ValidatorController(args, component) {
  _ValidatorController.prototype.validatorCount++;
  this.validatorTracker = args.validatorTracker;
  // Adding counter to validator id so we can support more than 1 instance of a validator with a given URL on the page
  this.id = args.url + "#" + this.validatorCount;
  this.logger = Log.getLogger("ValidatorController " + this.id);
  this.capability = args.capability;
  this.schema = args.capability.schema;
  this.getLastModification = args.getLastModification;
  this.onScheduleWork = args.onScheduleWork;
  this.isFormValid = args.isFormValid || Function.prototype;
  this.overrideFormValidity = args.overrideFormValidity || Function.prototype;
  // Note, this may be updated later by validator.account = account;
  this.account = args.account;
  this.setCfTarget(args.cfTarget);
  this.parameters = args.capability.parameters;
  var urlString = args.url;
  var VALIDATOR_URL = config.VALIDATOR_URL;
  if (VALIDATOR_URL) {
    urlString = VALIDATOR_URL + "/" + (args.url.charAt(0) === "/" ? args.url.substr(1) : args.url);
  } else if (args.url && args.url.indexOf('https://') !== 0) {
    urlString = location.protocol + "//" + location.host + "/" + (args.url.charAt(0) === "/" ? args.url.substr(1) : args.url);
  }
  this.formValidator = urlString;
  this.capabilityController = args.controller;
  this.capabilityController.addValidator(this);
  this.capabilityController.onValidatorEvent("load", {
    type: "start",
    source: this
  });
  this.populatePending = false;
  this.apiKey = null;
  this.component = component;
  this.capabilities = args.capabilities;
  this.initialLoad = true;
  this.toolchainId = args.toolchainId;
  this.toolchainBssAccountId = args.toolchainBssAccountId;
};
_ValidatorController.prototype = {
  validatorCount: 0,
  isValidatorV1: function isValidatorV1() {
    var form = this.schema.form;
    if (!form) {
      return false;
    }
    return !!form.find(function (v) {
      return v.type === 'validator' && v.url && v.url.toLowerCase().includes('validator-v1');
    });
  },
  isSpinnerValidator: function isSpinnerValidator() {
    var form = this.schema.form;
    if (!form) {
      return false;
    }
    var validator = form.find(function (v) {
      return v.type === 'validator';
    });
    if (!validator) {
      return false;
    }
    if (validator.url && validator.url.toLowerCase().includes('validator-v1')) {
      // for these validators, on change to a property will start spinner
      // for that property, and its dependants as determined by the params array
      return true;
    }
    // see below code for registry-namespace, has explicit pipeline spinner support
    // so not do spinner validator support for these 2 validators:
    // "/devops/setup/bm-helper/helper.html"
    // "/devops/setup/bm-helper/custom_helper.html"
    return false;
  },
  validatorRecursiveEnableSpinners: function validatorRecursiveEnableSpinners(root, level) {
    // Guard against infinite recursion
    if (!level) {
      level = 0;
    } else if (level > 10) {
      return;
    }

    // Process the properties
    if (this.schema && this.schema.properties) {
      var properties = this.schema.properties;
      for (var key in properties) {
        if (properties.hasOwnProperty(key)) {
          var property = properties[key];
          if (property && property.validator && property.validator.params) {
            if (property.validator.params.indexOf && property.validator.params.indexOf(root) !== -1 && property.spinner !== "start") {
              property.spinner = "start";
              this.validatorRecursiveEnableSpinners(key, level + 1);
            }
          }
        }
      }
    }
  },
  populate: function populate(changeSummary) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.updateSchema();
    var properties = this.schema.properties;
    this.lastChangeSummary = changeSummary;
    this.populatePending = true;
    var form = this.schema.form;
    var spinnerValidator = this.isSpinnerValidator();
    var version = 1;
    Object.keys(properties).forEach(function (item) {
      if (properties[item].$validate) {
        version = 2;
      }
    });
    Object.keys(this.parameters).forEach(function (p) {
      if (p === "__lastTimestamp") return;
      if (typeof properties[p] === "undefined") return;
      if (typeof this.parameters[p] === "undefined") return;
      if ((this.initialLoad || options.needsRepopulateInitital) && _typeof(properties[p]) === "object") {
        // Start the spinners on all properties on initial load, excluding validator-v1-loaded, -state
        properties[p].spinner = "start";
      }
      properties[p].value = this.parameters[p];
      if (changeSummary && changeSummary[p]) {
        properties[p].changed = true;
        if (spinnerValidator) {
          // Start the spinners on the changed property and any dependants
          properties[p].spinner = "start";
          this.validatorRecursiveEnableSpinners(p);
        } else {
          if (properties[p].changed) {
            if (p === "registry-region") {
              if (properties["registry-namespace"]) {
                properties["registry-namespace"].spinner = "start";
              }
              ;
            } else if (p.indexOf("resource-group") !== -1) {
              var prefix = p.split("-")[0];
              if (properties[prefix + "-cluster-name"]) {
                properties[prefix + "-cluster-name"].spinner = "start";
              }
              ;
            } else if (p.indexOf("region") !== -1) {
              var prefix = p.split("-")[0];
              if (properties[prefix + "-resource-group"]) {
                properties[prefix + "-resource-group"].spinner = "start";
              }
              ;
              if (properties[prefix + "-cluster-name"]) {
                properties[prefix + "-cluster-name"].spinner = "start";
              }
              ;
              if (properties[prefix + "-resource-group"]) {
                properties[prefix + "-resource-group"].spinner = "start";
              }
              ;
              if (properties[prefix + "-organization"]) {
                properties[prefix + "-organization"].spinner = "start";
              }
              ;
              if (properties[prefix + "-space"]) {
                properties[prefix + "-space"].spinner = "start";
              }
              ;
            } else if (p.indexOf("organization") !== -1) {
              var prefix = p.split("-")[0];
              if (properties[prefix + "-space"]) {
                properties[prefix + "-space"].spinner = "start";
              }
              ;
            }
          }
          form.forEach(function (item) {
            if (p.indexOf("api-key") !== -1 || item.type === "ibm-cloud-api-key") {
              this.apiKey = p;
              if (!(properties[p].value === "")) {
                Object.keys(properties).forEach(function (n) {
                  if (properties[n].spinner) {
                    if (version === 2 && properties[n].$validate && properties[n].$validate.params && properties[n].$validate.params.apiKey) {
                      if (properties[n].$validate.params.apiKey === p) {
                        properties[n].spinner = "start";
                      }
                    } else if (version === 1) {
                      properties[n].spinner = "start";
                    }
                  }
                });
              }
            } else {
              if (properties[p].$validate && properties[p].$validate.params && properties[p].$validate.params.apiKey) {
                this.apiKey = properties[p].$validate.params.apiKey;
              }
            }
          }.bind(this));
        }
      }
    }.bind(this));
    properties.__lastTimestamp = this.lastTimestamp = Date.now();
    this.logger.debug("populate " + new Date(this.lastTimestamp).toISOString() + " (" + this.lastTimestamp + ") <- sending lastTimestamp to server.");
    if (options.needsRepopulateInitital) {
      delete properties['validator-v1-loaded'];
      delete properties['validator-v1-state'];
    }
    var templateServices = this.capabilities && this.capabilities.getTopLevelData() && this.capabilities.getTopLevelData().services;
    var serviceInstance = this.capability.serviceInstance;
    var _ref = typeof serviceInstance !== 'undefined' && serviceInstance || {},
      configurationState = _ref.status,
      instanceId = _ref.instance_id;
    var data = {
      request: "populate",
      properties: properties,
      userInfo: this.component.props.userInfo,
      account: this.account,
      apiKey: this.apiKey,
      service_id: this.getServiceId() || "",
      cf: this.cfTarget,
      form: this.schema.form,
      state: configurationState ? configurationState.state : "create",
      instance_id: instanceId,
      vaultIntegrations: vaultUtil.getVaultIntegrations(templateServices),
      toolchainId: this.toolchainId,
      toolchainBssAccountId: this.toolchainBssAccountId
    };
    delete this.capabilityController.authorizationURI;
    this.logger.debug("Sending 'populate'");
    this.target.postMessage(data, this.src);
    this.capabilityController.onValidatorEvent("populate", {
      type: "start",
      source: this
    });
  },
  validate: function validate() {
    if (this.populatePending) {
      this.logger.debug("Skip requested validate: populate has not completed");
      return;
    }
    this.updateSchema();
    var properties = this.schema.properties;
    var templateServices = this.capabilities && this.capabilities.getTopLevelData() && this.capabilities.getTopLevelData().services;
    var serviceInstance = this.capability.serviceInstance;
    var _ref2 = typeof serviceInstance !== 'undefined' && serviceInstance || {},
      instanceId = _ref2.instance_id;
    var data = {
      request: "validate",
      userInfo: this.component.props.userInfo,
      validationType: "create",
      apiKey: this.apiKey,
      properties: properties,
      service_id: this.getServiceId() || "",
      vaultIntegrations: vaultUtil.getVaultIntegrations(templateServices),
      toolchainId: this.toolchainId,
      toolchainBssAccountId: this.toolchainBssAccountId,
      instance_id: instanceId
    };
    this.logger.debug("Sending 'validate'");
    this.target.postMessage(data, this.src);
    this.capabilityController.onValidatorEvent("validate", {
      type: "start",
      source: this
    });
  },
  authenticate: function authenticate(force) {
    this.updateSchema();
    var data = {
      request: "authenticate",
      userInfo: this.component.props.userInfo,
      service_id: this.getServiceId() || ""
    };
    // Do authentication once per service only
    if (force || !(data.service_id in this.validatorTracker.authMap)) {
      this.validatorTracker.authMap[data.service_id] = true;
      this.target.postMessage(data, this.src);
      this.capabilityController.onValidatorEvent("authenticate", {
        type: "start",
        source: this
      });
    } else {
      // Note prevent duplicate Authorize button here in the 'authenticate' phase,
      // but the 'populate' phase can show duplicate Authorize buttons.
      this.logger.debug("Skipping 'authenticate' to not duplicate Authorize button for service_id " + data.service_id);
    }
  },
  getParamDef: function getParamDef(theObject, property, key) {
    var paramDef = null;
    if (theObject instanceof Array) {
      for (var i = 0; i < theObject.length; i++) {
        paramDef = this.getParamDef(theObject[i], property, key);
        if (paramDef) {
          break;
        }
      }
    } else {
      for (var prop in theObject) {
        if (prop === 'key' && theObject[prop] === key && (theObject.enum || property.enum)) {
          return Object.assign({}, property || {}, theObject);
        }
        if (theObject[prop] instanceof Object || theObject[prop] instanceof Array) {
          paramDef = this.getParamDef(theObject[prop], property, key);
          if (paramDef) {
            break;
          }
        }
      }
    }
    return paramDef;
  },
  // Injects latest values from `this.parameters` (which is modified by the templating engine) into this.schema.properties.
  // This is needed to provide the most up-to-date field values in the validator payload.
  // TODO stop mutating the schema in this file
  updateSchema: function updateSchema() {
    var _this = this;
    var params = this.parameters;
    Object.keys(params).forEach(function (paramName) {
      var value = params[paramName];
      if (typeof value !== "undefined") {
        var obj = _this.schema.properties[paramName];
        if (obj && _typeof(obj) === "object") {
          obj.value = value;
        } else {
          _this.schema.properties[paramName] = {
            value: value
          };
        }
      }
    });
  },
  checkAndSetFormValidity: function checkAndSetFormValidity(key, value) {
    var properties = this.schema.properties;
    var isFormValid = true;
    Object.keys(properties).forEach(function (prop) {
      var prevProp = properties[prop];
      if (key === prop && prevProp.validationMessage && value) {
        delete properties[prop].validationMessage;
      } else if (prevProp.required && prevProp.validationMessage) {
        isFormValid = false;
      }
    }.bind(this));
    this.logger.debug("Before running populate/validate, is form valid? " + (isFormValid ? "yes" : "NO"));
    this.setFormValid(isFormValid);
  },
  setValidityOverride: function setValidityOverride(valid) {
    if (this.capability.overrideFormValidity !== valid) {
      this.capability.overrideFormValidity = valid;
      this.overrideFormValidity(valid);
      this.setFormValid(!valid);
    }
  },
  setFormValid: function setFormValid(value) {
    this.capability.isFormValid = this.capability.overrideFormValidity ? false : value;
    this.isFormValid(this.capability.overrideFormValidity ? false : value);
  },
  getFormValid: function getFormValid() {
    return this.capability.isFormValid;
  },
  setCfTarget: function setCfTarget(target) {
    this.cfTarget = target;
  },
  handleMessage: function handleMessage(event) {
    var _event$data$response;
    if (event.source !== this.target && (!this.capabilityController.popup || event.source !== this.capabilityController.popup)) {
      return;
    }
    if (!event.data.request || !event.data.response) {
      this.logger.error("Returned a bogus message:", JSON.stringify(event.data));
      return;
    }
    if (isErrorResponse(event.data.response) || ((_event$data$response = event.data.response) === null || _event$data$response === void 0 ? void 0 : _event$data$response.statusCode) === 401 && !event.data.response.authorizationURI) {
      // note, if 401 and git broker returned authorizationURI, will show Authorize button. Other 401 is a problem
      this.logger.error("Returned an error:", JSON.stringify(event.data));
      var errorMessage = event.data.response.description || JSON.stringify(event.data.response);
      this.capabilityController.formError = errorMessage;
      this.setFormValid(false);
      // don't attempt to handle this event
    } else {
      var handler = this.messageHandlers[event.data.request];
      if (typeof handler !== "function") {
        // don't know
        return;
      }
      handler.call(this, event);
    }
    this.capabilityController.onValidatorEvent(event.data.request, {
      type: "end",
      source: this
    });
  },
  // Maps event.data.request type to handler function
  messageHandlers: {
    "authenticate": function authenticate(event) {
      if (event.data.response.statusCode === 401) {
        analytics.track("auth.form.not-authenticated", {
          label: this.getServiceId()
        });
        this.logger.debug("Got 'authenticate'. Showing Authorize button.");
        this.capabilityController.authorizationURI = event.data.response.authorizationURI;
        this.setFormValid(false); // Not valid -- needs auth
      } else {
        //should be bound by ok code or something
        var serviceid = this.getServiceId();
        delete this.validatorTracker.authMap[serviceid];
        this.validatorTracker.authDone[serviceid] = true;
        analytics.track("auth.form.authenticated", {
          label: serviceid
        });
        this.logger.debug("Got 'authenticate'. Call populate on all validators with service_id: " + serviceid);
        this.validatorTracker.validators().forEach(function (validator) {
          var validatorServiceName = validator.capability.capabilityId;
          if (validatorServiceName === serviceid) {
            validator.setFormValid(true);
            validator.scheduleWork("populate");
          }
        });
      }
    },
    "oauth-return": function oauthReturn(event) {
      //TODO call capability controller
      var serviceId = this.getServiceId();
      delete this.validatorTracker.authMap[serviceId];
      analytics.track("auth.oauth.end", {
        label: serviceId
      });
      event.source.postMessage({
        request: "close"
      }, event.origin);
      this.logger.debug("Got 'oauth-return'. Call populate on all validators with service_id: " + serviceId);
      this.validatorTracker.validators().forEach(function (validator) {
        var validatorServiceName = validator.capability.capabilityId;
        if (validatorServiceName === serviceId) {
          // Remove the auth URI. This basically restarts the auth flow from scratch on the next
          // render pass.
          delete validator.capabilityController.authorizationURI;
          validator.setFormValid(true);
          validator.scheduleWork("populate");
        }
      });
    },
    "populate": function populate(event) {
      var ms;
      if ((ms = this.getResponseStaleness(event.data)) > 0) {
        this.logger.debug("Got 'populate': stale by " + ms + "ms. schedule populate");
        this.scheduleWork("populate");
        return;
      }
      this.populatePending = false;
      var authProperties = {};
      // Note, hack if stmt for localhost development, to avoid nginx 401 handling for Authorize button,
      // need to run bm-helper locally and prevent return of 401 on authorizationURI, and instead check for authorizationURI here.
      // if (event.data.response.statusCode === 401 || event.data.response.authorizationURI) {
      if (event.data.response.statusCode === 401) {
        authProperties.statusCode = 401;
        authProperties.authorizationURI = event.data.response.authorizationURI;
        delete event.data.response.status;
        delete event.data.response.statusCode;
        delete event.data.response.authorizationURI;
      }
      if (event.data.response.form) {
        this.schema.form = event.data.response.form;
        this.schema.populateComplete = true;
        delete event.data.response.form;
      }
      var properties = this.schema.properties = event.data.response;
      var changeSummary = Object.create(null);
      Object.keys(properties).forEach(function (prop) {
        var oldValue = this.parameters[prop];
        var newValue = valueOf(properties[prop]);
        if (properties[prop].type && properties[prop].type === "boolean") {
          if (newValue === undefined && oldValue === false) {
            newValue = false;
          }
        }
        if (typeof newValue !== "undefined" && oldValue !== newValue) {
          changeSummary[prop] = Change(oldValue !== newValue);
        }
        this.parameters[prop] = newValue;
      }.bind(this));

      // found &ENABLE_OPTIONAL_AUTHORIZE=true on url or in defaults.json
      var enableOptionalAuthorize = (this.component.props.context || {}).enableOptionalAuthorize || false;
      if (authProperties && authProperties.statusCode === 401) {
        analytics.track("auth.form.not-authenticated", {
          label: this.getServiceId()
        });
        this.logger.debug("Got 'populate'. Showing Authorize button.");
        // Note, not setting validatorTracker.authMap[serviceId] when 401 in populate phase
        this.capabilityController.authorizationURI = authProperties.authorizationURI;
        if (!enableOptionalAuthorize) {
          this.setFormValid(false); // Not valid -- needs auth

          // Turn off spinners - This is needed for git
          // integrations in the guided experience
          Object.keys(properties).forEach(function (prop) {
            if (properties[prop].spinner) {
              properties[prop].spinner = "hidden";
            }
          });
        }
      }
      // else || enableOptionalAuthorize
      if (!authProperties || authProperties.statusCode !== 401 || enableOptionalAuthorize) {
        this.logger.debug("Got 'populate'. Schedule validate");
        this.capabilityController.updateRefs(changeSummary);
        this.scheduleWork("validate");
      }
    },
    "validate": function validate(event) {
      var properties = this.schema.properties = event.data.response;
      var changeSummary = Object.create(null);
      var isFormValid = true;
      Object.keys(properties).forEach(function (prop) {
        var oldValue = this.parameters[prop];
        var newProp = properties[prop];
        var newValue = valueOf(newProp);
        var propsEnum = properties[prop].enum;
        var propDef = this.getParamDef(this.schema.form, properties[prop], prop);
        var setEnum = false;
        if ((newValue === undefined || newValue === '') && propsEnum && propsEnum.length > 0) {
          if (propDef && propDef.readonly && propDef.readonly === true) {
            if (_typeof(propsEnum[0]) === "object") {
              newValue = propsEnum[0].value;
              setEnum = true;
            } else {
              newValue = propsEnum[0];
              setEnum = true;
            }
          } else if (propDef === null) {
            if (_typeof(propsEnum[0]) === "object") {
              newValue = propsEnum[0].value;
              setEnum = true;
            } else {
              newValue = propsEnum[0];
              setEnum = true;
            }
          }
        }
        var changed = oldValue !== newValue || newProp.validationMessage || newProp.changed;
        if (typeof newValue !== "undefined" && changed) {
          if (setEnum) {
            this.parameters[prop] = newValue;
          } else {
            changeSummary[prop] = Change(oldValue !== newValue);
          }
        }
        if (newProp.required && newProp.validationMessage) {
          isFormValid = false;
        }
        //this.parameters[prop] = newValue;
        if (properties[prop].spinner) {
          properties[prop].spinner = "hidden";
        }
      }.bind(this));
      this.logger.debug("Got 'validate'. Is form valid? " + (isFormValid ? "yes" : "NO"));
      this.setFormValid(isFormValid);
      this.initialLoad = false;
      this.capabilityController.updateRefs(changeSummary);
    }
  },
  handleLoad: function handleLoad(event) {
    this.target = event.target.contentWindow;
    this.src = event.target.src;
    window.addEventListener("message", this.handleMessage.bind(this));
    this.logger.debug("Got 'load'. Call authenticate");
    this.authenticate();
    this.capabilityController.onValidatorEvent("load", {
      type: "end",
      source: this
    });
  },
  // Called when this ValidatorController is being evicted from the page.
  handleUnload: function handleUnload() {
    this.capabilityController.onValidatorEvent("unload", {
      source: this
    });
  },
  // If the model has changed since the given message was sent, returns how
  // stale the response is in ms. Otherwise returns 0
  getResponseStaleness: function getResponseStaleness(data) {
    var timestamp = data.response.__lastTimestamp || (data.body ? data.body.__lastTimestamp : undefined);
    var lastModification = this.getLastModification(this);
    this.logger.debug("validator getResponseStaleness " + new Date(timestamp || 0).toISOString() + " (" + timestamp + ") <- lastTimestamp returned from server.");
    var lastModificationStr = lastModification !== undefined ? new Date(lastModification).toISOString() : undefined;
    this.logger.debug("validator getResponseStaleness " + lastModificationStr + " (" + lastModification + ") <- lastModification in browser");
    var staleness;
    if (typeof timestamp === "number" && lastModification > timestamp) {
      staleness = lastModification - timestamp;
    } else {
      staleness = 0;
    }
    this.logger.debug("validator getResponseStaleness " + new Date(staleness).toISOString().split('T')[1] + " (" + staleness + ")  <- staleness");
    return staleness;
  },
  scheduleWork: function scheduleWork(type) {
    this.onScheduleWork(type, [{
      capability: this.capability,
      changeSummary: null
    }]);
  },
  // returns id of the associated capability
  getServiceId: function getServiceId() {
    return this.capability.capabilityId || this.capability.service_id || this.capability["service-category"];
  }
};
function isErrorStatusCode(value) {
  return typeof value === "number" && 400 <= value && value <= 599;
}
function isErrorResponse(response) {
  if (response.statusCode === 401) {
    // 401 is not an error, it's reserved for auth flow
    return false;
  }
  return isErrorStatusCode(response.statusCode) || /error/i.test(response.status);
}
function Change(valueChanged) {
  return {
    source: "validator",
    valueChanged: valueChanged
  };
}
function valueOf(prop) {
  return prop.value;
}
var Validator = /*#__PURE__*/function (_React$Component) {
  function Validator(props) {
    var _this2;
    _classCallCheck(this, Validator);
    _this2 = _callSuper(this, Validator, [props]);
    _this2.state = {
      val: new _ValidatorController(_this2.props, _this2)
    };
    return _this2;
  }
  _inherits(Validator, _React$Component);
  return _createClass(Validator, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.listener = this.state.val.handleLoad.bind(this.state.val);
      this.refs.iFrame.addEventListener('load', this.listener);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.refs.iFrame.removeEventListener('load', this.listener);
      this.state.val.handleUnload();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.val.isValidatorV1() && this.state.val.formValidator) {
        // Forward on the url params to validator-v1
        // This is needed for IKS
        var href = window && window.location && window.location.href;
        if (href) {
          var parts = href.split('?');
          if (parts[1]) {
            var url = this.state.val.formValidator.split('?')[0] + '?' + parts[1];
            return /*#__PURE__*/React.createElement("iframe", {
              ref: "iFrame",
              className: "formValidator",
              src: url
            });
          }
        }
      }
      return /*#__PURE__*/React.createElement("iframe", {
        ref: "iFrame",
        className: "formValidator",
        src: this.state.val.formValidator
      });
    }
  }]);
}(React.Component);
export { Validator as default };